import React from 'react';
import SuperAdminDashboard from '../components/admin/SuperAdminDashboard';

const SuperAdmin: React.FC = () => {
  return <SuperAdminDashboard />;
};

export default SuperAdmin;